import { boot } from 'quasar/wrappers'
import { initSentry } from './sentry'
import { bootErrorMessage } from './error/bootErrorMessage'
import { addBreadcrumb, captureException } from '@sentry/vue'

// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ app, router }) => {
  try {
    // initialize sentry
    initSentry({ app, router })
  } catch (error) {
    console.trace()
    console.error(error, { stage: 'bootErrCatch' })
    console.error({ app })
    console.error({ router })
    captureException(error)
    bootErrorMessage(error, { stage: 'bootErrCatch' })
  }
})
